D.addEventListener("DOMContentLoaded", function() {

	let images = D.querySelectorAll('.js-load-images img');

	if(images) {
		const loadImages = () => {
			let scrollBarPosition = W.pageYOffset | D.body.scrollTop;

			// if( scrollBarPosition  > 150) {

				images.forEach(current => {
					let urlImg = current.getAttribute("data-src");

					current.setAttribute('src', urlImg)

				})
			 
		}
		W.addEventListener("scroll", loadImages);

		loadImages();
	}



	// let iframes = D.querySelectorAll('.js-load-iframe iframe');

	// if(iframes) {
	// 	const loadIframes = () => {
	// 		let scrollBarPosition = W.pageYOffset | D.body.scrollTop;

	// 		if( scrollBarPosition  > 150) {

	// 			iframes.forEach(current => {
	// 				current.style.display = "block";
	// 			})
	// 		} 
	// 	}
	// 	W.addEventListener("scroll", loadIframes);

	// 	loadIframes();
	// }



})